/**
 * Scene data for the Insidermark journey. Seedance 2.5 film (forging, field,
 * mill, truck x-ray, train x-ray, container, seal) grouped into five chapters. Posters are the exact first frame of each
 * encoded segment. Copy is language-specific and assembled in the route.
 */
import type {
  ScrollScrubScene,
  ScrollScrubTheme,
} from "@/components/scroll-scrub/scroll-scrub";
import type { Dictionary } from "@/content/site";

export const scrollScrubTheme: ScrollScrubTheme = {
  accent: "#d6432a",
  background: "#0b1622",
  ink: "#eef1f4",
  muted: "#9aa7b4",
};

const media = [1, 2, 3, 4, 5].map((n) => ({
  clip: `/assets/world/scene-0${n}.mp4`,
  poster: `/assets/world/scene-0${n}-poster.webp`,
  mobileClip: `/assets/world/scene-0${n}-mobile.mp4?v=intra`,
  mobilePoster: `/assets/world/scene-0${n}-mobile-poster.webp`,
}));

const align: ("left" | "right")[] = ["left", "right", "left", "right", "left"];

export function buildScenes(t: Dictionary): ScrollScrubScene[] {
  return t.journey.map((ch, i) => ({
    id: ch.id,
    label: ch.label,
    title: ch.title,
    body: ch.body,
    kicker: ch.kicker,
    tags: ch.tags,
    align: align[i],
    scroll: [3.4, 2.6, 2.0, 2.2, 3.0][i] ?? 2.0,
    linger: i === 0 ? 0.05 : 0.12,
    ...(i === 0 ? { copyFade: [0.04, 0.16] as [number, number] } : {}),
    ...(i === t.journey.length - 1 ? { epilogue: t.hero.slogan, epilogueAt: [0.66, 0.78, 1.1, 1.2] as [number, number, number, number] } : {}),
    objectPosition: "center center",
    mobileObjectPosition: "center center",
    ...media[i],
  }));
}

/** Module constants so the controller is built once per language. */
export const scrollScrubScenesByLang: Record<string, ScrollScrubScene[]> = {};
